import { render, staticRenderFns } from "./setEmail.vue?vue&type=template&id=25fea7f3&scoped=true&"
import script from "./setEmail.vue?vue&type=script&lang=js&"
export * from "./setEmail.vue?vue&type=script&lang=js&"
import style0 from "./setEmail.vue?vue&type=style&index=0&id=25fea7f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fea7f3",
  null
  
)

export default component.exports